<template>
	<div class="tag-manager-filters" >
		<div class="filters" >
			<div class="tag-search">
				<ui-search-box
					v-model="filters.data.search"
					:event="searchEvent"
					placeholder="Buscar por nome ou ID"
				/>
			</div>
		</div>

		<div class="filters" >
			<ui-select-2
				v-model="filters.data.orderby"
				:data="orderOptions"
				:loading="filters.loader.orderby"
				:search="false"
				align="left"
				item-label="label"
				label="Ordenar por:"
				return-value="value"
				placeholder="Ordenar por..."
			/>
			<ui-select-2
				v-model="filters.data.order"
				:data="filters.order"
				:search="false"
				align="left"
				item-label="label"
				label="Ordem:"
				return-value="value"
				placeholder="Ordenar por..."
			/>
			<ui-select-2
				v-model="filters.data.filter"
				:data="filterOptions"
				:loading="filters.loader.filter"
				:search="false"
				align="right"
				label="Filtrar por:"
				item-label="label"
				return-value="value"
				placeholder="Filtrar por..."
			/>

			<ui-button design="primary md" @click="applyFilterHandler" >
				Aplicar
			</ui-button>
		</div>
	</div>
</template>

<script>
	import { uiSelect2 } from '@/components/ui/form'
	import { uiSearchBox } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'

	const defaultLoader = {
		orderby: false,
		filter: false
	}

	const defaultOrderData = [
		{
			value: 'asc',
			label: 'Crescente'
		},
		{
			value: 'desc',
			label: 'Decrescente'
		}
	]

	const defaultFilters = {
		orderby: null,
		filter: null,
		search: null,
		order: null
	}

	export default {
		components: {
			uiSelect2,
			uiSearchBox,
			uiButton,
		},

		props: {
			value: {
				type: Object,
				required: false
			},

			searchEvent: {
				type: String,
				required: true
			},

			orderOptions: {
				type: Array,
				default: () => []
			},

			filterOptions: {
				type: Array,
				default: () => []
			}
		},

		mounted() {
			this.$emit('input', this.filters)
		},

		data() {
			return {
				filters: {
					data: { ...defaultFilters },
					loader: { ...defaultLoader },
					order: [...defaultOrderData]
				}
			}
		},

		methods: {
			applyFilterHandler() {
				this.$emit('applyFilter', this.filters)
			}
		},

		watch: {
			value(value) {
				if (value) this.filters = value
			},

			filters(value) {
				this.$emit('input', value)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
